module.exports = __webpack_public_path__ + "static/scale-model-of-eagle-scout-memorial-in-kansas-city-missouri-81b4a214a5540496b3c278b0ad52ac57.png";